var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PathObjectData = require("./../../svg/pathObjectData.js");
var PathData = require("./../../svg/pathData.js");
var PathType = require("./../../svg/pathType.js");
var FabData = require("./fabData.js");

var CopperPourData = require("./copperPourData.js");
var PcbTerminal = require("./pcbTerminal.js");
var HoleData = require("./../../footprint/holeData.js");
var PcbHole = require("./pcbHole.js");
var RoutingSegmentData = require("./routingSegmentData.js");
var RoutingVertexData = require("./routingVertexData.js");
var ComponentInstanceData = require("../netlist/componentInstanceData.js");

var fabSettings = require("./fabSettings.js");
//var PthPadData = require("./../../footprint/pthPadData.js");
var FootprintData = require("./../../footprint/footprintData.js");
var cio_config = require("cio-config");

var PcbData = function (init, numberOfLayers) {
    var self = this;

    this.makeObservableTreeNode();

    this.pcbElements        = this.set("pcbElements", true);
    this.routingSegments    = this.set("routingSegments", true);
    this.routingVertices    = this.set("routingVertices", true);
    this.copperPours        = this.set("copperPours", true);
    this.vias               = this.set("vias", true);
    this.holes              = this.set("holes", true);
    this.silkscreen         = this.list("silkscreen", true);
    this.solderMask         = this.set("solderMask", true);
    this.solderPaste        = this.set("solderPaste", true);
    this.copperRestricts    = this.set("copperRestricts", true);
    this.componentRestricts = this.set("componentRestricts", true);
    this.viaRestricts       = this.set("viaRestricts", true);
    this.glue               = this.set("glue", true);
    this.drawings           = this.list("drawings", true);

    this.outline            = this.value("outline", true);

    this.fab                = this.value("fab", true);

    this.number_of_layers   = this.value("number_of_layers", true, cio_config.types.float.validator);

    this.boardThickness = 1600;//1600  // extrusion amount
    this.copperThickness = 34;  // extrusion amount
    this.silkscreenThickness = 40;  // extrusion amount
    this.curvePrecision3d = 25; // precision for curve (higher is less)
    this.segmentPrecision3d = 2; // segments per quarter circle of silks, half circle of traces

    this.layerStack = this.shadow("layerStack",
        function() {
            var numberOfInnerLayers = self.number_of_layers()-2;
            var layerStack = new lib_core.Collections.List();
            for(var i=0; i<numberOfInnerLayers; i++) {
                (function () {
                    var layerIndex;
                    if (i < Math.ceil(numberOfInnerLayers/2)) {
                        layerIndex = 2*(i+1);
                        layerStack.push(layerIndex);
                    } else {
                        var j = numberOfInnerLayers - i - 1;
                        layerIndex = 2*(j+1)+1;
                        layerStack.push(layerIndex);
                    }
                })();
            }
            layerStack.add(0, 0);
            layerStack.push(1);
            return layerStack;
        },
        null,
        [this.number_of_layers]
    );

    this.buildVertexConnectedSegmentMap();
    this.create3dShadows();

    if(init) this.createDefaultOutline();
    if(init) this.createDefaultFab();
    if(numberOfLayers !== undefined) this.number_of_layers(numberOfLayers);

    this.onInit(this, this.initialize);
};
lib_core.mixin(PcbData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PcbData, "PcbData");

module.exports = PcbData;

PcbData.geometryPrecision = function() {
    return 1000 * 5e-3;
};

PcbData.prototype.geometryPrecision = function() {
    return PcbData.geometryPrecision();
};

PcbData.prototype.initialize = function () {
    var self = this;

    this.createLayerSets();
    this.createNetSets();
    this.initializeSpatialIndex();

    this.number_of_layers.onChange("numberOfLayersChange", function (value, old) {
        if(value < old) {
            var layersToRemove = new lib_core.Collections.HashSet();
            for(var i=value; i<old; i++) layersToRemove.add(i);
            self.removeElementsOnLayers(layersToRemove);
        }
        self.createLayerSets();
        self.initializeSpatialIndex();
    });
};

PcbData.prototype.createDefaultOutline = function () {
    var path = new PathData(new lib_geometry.Coord(0,0), 100, null);
    path.addObject(new PathObjectData(new lib_geometry.Coord(57150,0), PathType.LINE));
    path.addObject(new PathObjectData(new lib_geometry.Coord(57150,53340), PathType.LINE));
    path.addObject(new PathObjectData(new lib_geometry.Coord(0,53340), PathType.LINE));
    path.closed(true);
    path.fill(true);
    this.outline(path);
};

PcbData.prototype.createDefaultFab = function () {
    var fab = new FabData(fabSettings.oshPark);
    this.fab(fab);
};


PcbData.prototype.createLayerSets = function () {
    var self = this;

    if(!this.layerElementsMap) {
        this.layerElementsMap = new lib_core.Collections.HashMap();
    }

    for(var i=0; i<this.number_of_layers(); i++) {
        var layerSet = this.layerElementsMap.get(i);
        if(!layerSet) {
            layerSet = this.shadowSet("layerSet_"+i, false);
            this.layerElementsMap.put(i, layerSet);
        }
    }

    var onAddElement = function (index, element) {
        for(var i=0; i<self.number_of_layers(); i++) {
            if(!element.getLayers || element.getLayers().contains(i))
                self.layerElementsMap.get(i).add(element);
        }
        switch (element.constructor) {
            case RoutingSegmentData:
                element.layerIndex.onChange("changeLayerSet", function (value, old) {
                    if(old !== value && element.isAlive()) {
                        self.layerElementsMap.get(old).remove(element);
                        self.layerElementsMap.get(value).add(element);
                    }
                });
                break;
            case PcbTerminal:
                element.parent().onTopLayer.onChange("changeLayerSet_"+element.$id, function (value, old) {
                    if(old !== value && element.isAlive()) {
                        self.layerElementsMap.forEach(function (layerIndex, layerSet) {
                            layerSet.remove(element);
                        });
                        element.getLayers().forEach(function(layerIndex) {
                            self.layerElementsMap.get(layerIndex).add(element);
                        });
                    }
                });
                element.onDie("changeLayerSet", function() {
                    self.layerElementsMap.forEach(function (layerIndex, layerSet) {
                        layerSet.remove(element);
                    });
                    element.parent().onTopLayer.removeHandlers("changeLayerSet_"+element.$id);
                });
                break;
            default:
        }
    };
    var onRemoveElement = function (index, element) {
        for(var i=0; i<self.number_of_layers(); i++) {
            self.layerElementsMap.get(i).remove(element);
        }
    };

    // Pads
    this.pcbElements.forEach(function(element) {
        element.pads.forEach(function(pad){
            pad.onInit("intialAddToLayerSet", function(){onAddElement(null, this); }, 100); // existing pads can only be added to the layerSet after they are initialised
        });
        element.holes.forEach(function(hole){
            hole.onInit("intialAddToLayerSet", function(){onAddElement(null, this); }, 100); // existing holes can only be added to the layerSet after they are initialised
        });
    });
    this.pcbElements.onAdd("syncLayerSet", function (index, element) {
        element.pads.forEach(onAddElement);
        element.holes.forEach(onAddElement);
    });
    this.pcbElements.onRemove("syncLayerSet", function (index, element) {
        element.pads.forEach(onRemoveElement);
        element.holes.forEach(onRemoveElement);
    });

    // Routing Segments
    this.routingSegments.forEach(onAddElement);
    this.routingSegments.onAdd("syncLayerSet", onAddElement);
    this.routingSegments.onRemove("syncLayerSet", onRemoveElement);
    // vias
    this.vias.forEach(onAddElement);
    this.vias.onAdd("syncLayerSet", onAddElement);
    this.vias.onRemove("syncLayerSet", onRemoveElement);
    // holes
    this.holes.forEach(onAddElement);
    this.holes.onAdd("syncLayerSet", onAddElement);
    this.holes.onRemove("syncLayerSet", onRemoveElement);
    // copperPours
    this.copperPours.forEach(onAddElement);
    this.copperPours.onAdd("syncLayerSet", onAddElement);
    this.copperPours.onRemove("syncLayerSet", onRemoveElement);
};

PcbData.prototype.removeElementsOnLayers = function (layersToRemove) {
    var self = this;
    layersToRemove.forEach(function (layer) {
        self.layerElementsMap.get(layer).forEach(function (el) {
            var hasOtherLayer = el.getLayers().some(function (layer) {
                return !layersToRemove.contains(layer);
            });
            if (el.remove && !hasOtherLayer) el.remove();
        });
    });
};

PcbData.prototype.createNetSets = function () {
    var self = this;

    // TODO: this should move to pcbNetData.js once it exists
    this.netElementsMap = new lib_core.Collections.HashMap();

    var getPcbTerminal = function (logicTerminal) {
        var pcbTerminal = null;
        self.pcbElements.forEach(function(element) {
            element.pads.forEach(function(pad) {
                if(pad.getLogicTerminal() === logicTerminal) pcbTerminal = pad;
            });
        });
        return pcbTerminal;
    };

    // TODO: is there a better way?
    var syncNetSet = function (netData, netSet) {
        var onAddTerminal = function (index, element) {
            var pcbTerminal = getPcbTerminal(element);
            if(pcbTerminal) netSet.add(pcbTerminal);
        };

        var onRemoveTerminal = function (index, element) {
            var pcbTerminal = getPcbTerminal(element);
            if(pcbTerminal) netSet.remove(pcbTerminal);
        };

        // terminals
        netData.terminals.forEach(onAddTerminal);
        netData.terminals.onAdd({}, onAddTerminal);
        netData.terminals.onRemove({}, onRemoveTerminal);
    };

    var createNetSet = function (net) {
        var netSet = new lib_core.ObservableSet();
        syncNetSet(net, netSet);
        self.netElementsMap.put(net, netSet);
        return netSet;
    };

    var onAddElement = function (index, element) {
        var netSet = self.netElementsMap.get(element.net());
        if(!netSet) {
            netSet = createNetSet(element.net());
        }
        netSet.add(element);
    };

    var onRemoveElement = function (index, element) {
        var netSet = self.netElementsMap.get(element.net());
        if(netSet) {
            netSet.remove(element);
            if(!netSet.size()) self.netElementsMap.remove(element.net());
        }
    };

    // Routing Segments
    this.routingSegments.forEach(onAddElement);
    this.routingSegments.onAdd("syncNetSets", onAddElement);
    this.routingSegments.onRemove("syncNetSets", onRemoveElement);
    // Routing Vertices
    this.routingVertices.forEach(onAddElement);
    this.routingVertices.onAdd("syncNetSets", onAddElement);
    this.routingVertices.onRemove("syncNetSets", onRemoveElement);
    // vias
    this.vias.forEach(onAddElement);
    this.vias.onAdd("syncNetSets", onAddElement);
    this.vias.onRemove("syncNetSets", onRemoveElement);
    // copper pours
    this.copperPours.forEach(onAddElement);
    this.copperPours.onAdd("syncNetSets", onAddElement);
    this.copperPours.onRemove("syncNetSets", onRemoveElement);

    this.parent().netlist().nets.forEach(function(net) {
        var netSet = self.netElementsMap.get(net);
        if(!netSet) createNetSet(net);
    });
    this.parent().netlist().nets.onAdd("syncNetSets", function(set, net) {
        var netSet = self.netElementsMap.get(net);
        if(!netSet) createNetSet(net);
    });
    this.parent().netlist().nets.onRemove("syncNetSets", function(set, net) {
        self.netElementsMap.remove(net);
    });
};

var ViaData = require("./viaData.js");//put this here to prevent problem with cyclic dependency
PcbData.getSpatialIndexTriggers = function (element) {
    switch (element.constructor) {
        case PcbTerminal:
            return [[element.pos, element.pos.onChange],
                    [element.angle, element.angle.onChange]];
        case RoutingSegmentData:
            return [[element.startVertex, element.startVertex.onBubble],
                    [element.endVertex, element.endVertex.onBubble],
                    [element.width, element.width.onChange],
                    [element.layerIndex, element.layerIndex.onChange]];
        case ViaData:
            return [[element.pos, element.pos.onChange],
                    [element.endsize, element.endsize.onChange]];
        case PcbHole:
            return [[element.pos, element.pos.onChange],
                    [element.angle, element.angle.onChange],
                    [element.description, element.description.onChange]];
        case HoleData:
            return [[element.pos, element.pos.onChange],
                    [element.angle, element.angle.onChange],
                    [element.shape, element.shape.onBubble]];
        case CopperPourData:
            return [[element.shape, element.shape.onBubble],
                    [element.rank, element.rank.onChange],
                    [element.isolation, element.isolation.onChange],
                    [element.layerIndex, element.layerIndex.onChange],
                    [element.thermals, element.thermals.onChange],
                    [element.orphans, element.orphans.onChange]];
        default:
            return  [];
    }
};

PcbData.prototype.initializeSpatialIndex = function () {
    var self = this;

    this.spatialIndexMap = new lib_core.Collections.HashMap();

    for(var i=0; i<this.number_of_layers(); i++) {
        (function () {
            var layer = i;

            var layerSet = self.layerElementsMap.get(layer);

            var layerIndex = new lib_core.SpatialIndex(
                    "rbush",
                    layerSet,
                    function (element) {
                        var poly = element.segmentedGeometry(PcbData.geometryPrecision(), layer);
                        if(poly) return poly.getBB();
                        else return null;
                    },
                    PcbData.getSpatialIndexTriggers
                );
            self.spatialIndexMap.put(i, layerIndex);
        })();
    }
};

PcbData.prototype.buildVertexConnectedSegmentMap = function () {
    var self = this;

    this.vtxConSegMap = new lib_core.ObservableMap();

    var addSegment = function (segment) {
        var addVertex = function (vertexMember) {
            if(vertexMember()) {
                var set = self.vtxConSegMap.get(vertexMember());
                if(!set) {
                    set = new lib_core.Collections.HashSet();
                    self.vtxConSegMap.put(vertexMember(), set);
                }
                set.add(segment);
            }
            vertexMember.onChange({}, function(value, old) {
                if(old !== value) {
                    var oldSet = null;
                    if(old && segment.otherVertex(vertexMember()) !== old) {
                        oldSet = self.vtxConSegMap.get(old);
                        if(oldSet) {
                            if(!oldSet.size()) {
                                self.vtxConSegMap.remove(old);
                            }
                        }
                    }
                    if(value) {
                        var set = self.vtxConSegMap.get(value);
                        if(!set) {
                            set = new lib_core.Collections.HashSet();
                            self.vtxConSegMap.put(value, set);
                        }
                        set.add(segment);
                    }
                }
            });
        };
        addVertex(segment.startVertex);
        addVertex(segment.endVertex);
    };
    var removeSegment = function (segment) {
        var startVertex = segment.startVertex();
        if(startVertex) {
            var set = self.vtxConSegMap.get(startVertex);
            set.remove(segment);
        }
        var endVertex = segment.endVertex();
        if(endVertex) {
            var set = self.vtxConSegMap.get(endVertex);
            set.remove(segment);
        }
    };
    var removeVertex = function (vertex) {
        console.assert(!(vertex instanceof PcbTerminal));
        self.vtxConSegMap.remove(vertex);
    };

    this.routingSegments.forEach(addSegment);
    this.routingSegments.onAdd("vtxConSegMap", addSegment);
    this.routingSegments.onRemove("vtxConSegMap", removeSegment);
    this.routingVertices.onRemove("vtxConSegMap", removeVertex);
};

PcbData.prototype.getTraceElements = function(net) {
    var elements = new lib_core.Collections.HashSet();
    var netElements = this.netElementsMap.get(net);
    elements = netElements.filter(function (el) {
        return !(el instanceof CopperPourData || el instanceof RoutingVertexData);
    });
    return elements;
};

PcbData.prototype.getUnconnectedTraceElements = function() {
    var elements = new lib_core.Collections.HashSet();
    this.pcbElements.forEach(function(pcbElement) {
        pcbElement.pads.forEach(function(pad) {
            if(!pad.net()) elements.add(pad);
        });
    });
    this.routingSegments.forEach(function(routingSegment) {
        if(!routingSegment.net()) elements.add(routingSegment);
    });
    this.vias.forEach(function(via) {
        if(!via.net()) elements.add(via);
    });
    return elements;
};

PcbData.prototype.convertInternalToStackIndex = function(internalIndex) {
    var internalToStack = new lib_core.Collections.HashMap();
    this.layerStack().forEach(function (stackIndex, internalIndex) {
        internalToStack.put(internalIndex, stackIndex);
    });
    return internalToStack.get(internalIndex);
};

PcbData.prototype.getPcbElement = function(componentInstance) {
    console.assert(componentInstance instanceof ComponentInstanceData);
    var pcbElement = null;
    this.pcbElements.forEach(function(pcbElement) {
        if(pcbElement.componentInstance === componentInstance)
            pcbElement = pcbElement;
    });
    return pcbElement;
};

PcbData.prototype.sanityCheck = function() {
    lib_core.ObservableTreeNode.sanityCheck.call(this);

    var netlist = this.parent().netlist();

    var count_footprints = 0;
    netlist.componentInstances.forEach(function(componentInstance) {
        count_footprints += componentInstance.packageInstances.size() > 0;
    });
    console.assert(this.pcbElements.size() === count_footprints, "Expect one pcb element per component (if that component has at least one package)");
};

PcbData.prototype.create3dShadows = function () {
    var self = this;

    this.allHoles = this.cachedFunction("allHoles",
        function(){
            var precision = this.curvePrecision3d;
            var outlines = [];
            self.holes.forEach(function(id, hole){
                var geom = hole.outlineGeometry(precision);
                outlines.push(new lib_geometry.Polygon(geom.points));
            });

            self.vias.forEach(function(id, via){
                if(via.startLayer() != 0 || via.endLayer() != 1) return;
                var geom = via.segmentedHoleGeometry(precision);
                outlines.push(new lib_geometry.Polygon(geom.points));
            });

            self.pcbElements.forEach(function(id, element){
                var geoms = element.allHoles(precision);
                for(var i = 0; i < geoms.length; i++){
                    var curr = geoms[i].copy();
                    curr = curr.translate(element.pos());
                    curr = curr.rotate(element.angle(), element.pos());
                    outlines.push(new lib_geometry.Polygon(curr.points));
                }
            });

            return lib_geometry.Union(outlines, []);
        },
        [[this.pcbElements, this.pcbElements.onBubble],
         [this.holes, this.holes.onBubble],
         [this.vias, this.vias.onBubble]]
    );

    this.boardMesh = this.cachedFunction("boardMesh",
        function (){
            var precision = this.curvePrecision3d;
            var geom = lib_geometry.Union([this.outline().outlineGeometry(precision)], this.allHoles(precision));
            var mesh = (new lib_geometry.TriangleMesh()).fromPolygon(geom, this.boardThickness);
            mesh = mesh.copy().translate(0,0,this.copperThickness);
            return mesh;
        },
        [[this.outline, this.outline.onBubble], 
          this.allHoles]
    );

    this.copperMesh = this.cachedFunction("copperMesh",
        function (){
            var precision = this.curvePrecision3d;
            var tracePrecision = this.segmentPrecision3d;
            var merged = new lib_geometry.TriangleMesh();

            this.pcbElements.forEach(function (id, element){
                var mesh = element.copperMesh(precision);
                if(mesh.isEmpty()) return;
                mesh = mesh.copy();
                if(!element.onTopLayer()){
                    mesh = mesh.rotateY(180);
                    mesh = mesh.translate(0, 0, self.boardThickness + self.copperThickness * 2 );
                }
                mesh = mesh.translate(element.pos().x, element.pos().y, 0);
                mesh = mesh.rotateAround2d(element.angle(), element.pos());
                merged.mergeMesh(mesh);
            });

            this.routingSegments.forEach(function (id, seg){
                //if(seg.layerIndex() == 0 || seg.layerIndex() == 1){
                    var mesh = seg.mesh(tracePrecision);
                    if(!mesh || mesh.isEmpty()) return;
                    merged.mergeMesh(mesh);
                //}
            });

             this.vias.forEach(function (id, via){
                var mesh = via.mesh(precision);
                if(mesh.isEmpty()) return;
                merged.mergeMesh(mesh);
            });

            return merged;
        },
        [[this.pcbElements, this.pcbElements.onBubble],
         [this.routingSegments, this.routingSegments.onBubble],
         [this.copperPours, this.copperPours.onBubble],
         [this.vias, this.vias.onBubble]]
    );

    this.silkscreenMesh = this.cachedFunction("silkscreenMesh",
        function (){
            var precision = this.curvePrecision3d;
            var segmentPrecision = this.segmentPrecision3d;
            var merged = new lib_geometry.TriangleMesh();

            this.pcbElements.forEach(function (id, element){
                var mesh = element.silkscreenMesh(precision);
                if(mesh.isEmpty()) return;
                mesh = mesh.copy();
                if(!element.onTopLayer()){
                    mesh = mesh.rotateY(180);
                    mesh = mesh.translate(0, 0, self.boardThickness + self.silkscreenThickness * 2 + 5);
                } else {
                    mesh = mesh.translate(0, 0,  self.copperThickness - self.silkscreenThickness - 5 );
                }
                mesh = mesh.translate(element.pos().x, element.pos().y, 0);
                mesh = mesh.rotateAround2d(element.angle(), element.pos());
                merged.mergeMesh(mesh);
            });

            this.silkscreen.forEach(function (id, silk){
                var mesh = silk.shape().mesh(precision);
                if(mesh.isEmpty()) return;
                mesh = mesh.copy();

                if(silk.layerIndex.contains(0)){
                    mesh = mesh.translate(0, 0,  self.copperThickness - self.silkscreenThickness - 5);
                }else if(silk.layerIndex.contains(1)){
                    mesh = mesh.translate(0, 0, self.boardThickness + self.silkscreenThickness * 2 + 5);
                }else{
                    console.error("SILK on inner layer");
                }
                merged.mergeMesh(mesh);
            });

            return merged;
        },
        [[this.pcbElements, this.pcbElements.onBubble],
         [this.silkscreen, this.silkscreen.onBubble]]
    );
};

PcbData.prototype.getIntersectingHoles = function(myData, precision){
   
    var index = this.spatialIndexMap.get(myData.layerIndex());
    var objectNet = myData.net ? myData.net() : null;

    var candidates = []
    var poly = myData.getSegmentedGeometry(myData.layerIndex());
    if(poly) {
        var bb = poly.getBB();
        candidates = index.query(bb);
    }
    var holes = [];
    for (var i = candidates.length - 1; i >= 0; i--) {
        if(candidates[i] instanceof HoleData){
            holes.push(candidates[i].segmentedGeometry(precision));

        } else if(candidates[i] instanceof PcbHole ){
            var geom = candidates[i].segmentedGeometry(precision);
            holes.push(geom);

//        } else if(candidates[i] instanceof PthPadData ){
//            holes.push(candidates[i].getDrillSegmentedGeometry(precision));

        } else if(candidates[i] instanceof PcbTerminal ){
            //if(candidates[i].description() instanceof PthPadData){
            //    var geom = candidates[i].segmentedHoleGeometry(precision);
            //    holes.push(geom);
            //}
        }
        else if(candidates[i] instanceof ViaData ){
            holes.push(candidates[i].getSegmentedHoleGeometry(precision));
        }
                
    };
    return holes;
};

PcbData.prototype.getRealLayer = function(layerInd, numLayers){
    if(layerInd % 2 == 0){
        return layerInd / 2;
    } else {
        return (numLayers / 2) + ( (numLayers - layerInd - 1) / 2 );
    }
}
